<div class="ui-g ui-fluid">
  <div class="ui-g-12 ui-lg-12">
    <div class="card card-w-title">
      <h1>Manage Engineius Regions Postcodes</h1>

      <p-table
        selectionMode="single"
        [value]="page.items"
        [lazy]="true"
        [rows]="10"
        [responsive]="true"
        [paginator]="true"
        rowHover="true"
        resizableColumns="true"
        [totalRecords]="page.total"
        (onLazyLoad)="onGridLazyLoad($event)"
        (onRowSelect)="onRowSelect($event)"
        *ngIf="isLoaded; else loading"
      >
        <ng-template pTemplate="header">
          <tr>
            <th>Name</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-item>
          <tr [pSelectableRow]="item" (dblclick)="onRowDblclick(item)">
            <td>{{ item.name }}</td>
          </tr>
        </ng-template>
      </p-table>

      <!-- DATATABLE DEPRECATED --
      <p-dataTabl selectionMode="single" [value]="page.items" [lazy]="true" [rows]="10" [responsive]="true"
                   [paginator]="true" rowHover="true" resizableColumns="true"
                   [totalRecords]="page.total" (onLazyLoad)="onGridLazyLoad($event)" (onRowSelect)="onRowSelect($event)"
                   (onRowDblclick)="onRowDblclick($event)"
                   *ngIf="isLoaded; else loading">
        <p-header>List of Region</p-header>
        <p-column field="name" header="Name" [filter]="true" filterPlaceholder="Search contains"
                  filterMatchMode="contains" [sortable]="true" [editable]="false" [style]="{'width': '45%'}"></p-column>
      </p-dataTable>
      -->

      <div class="footerPanel ui-grid-row">
        <button
          type="button"
          class="btn-to-right"
          pButton
          (click)="onEdit()"
          label="Edit"
          icon="fa ui-icon-mode-edit"
        ></button>
      </div>

      <p-dialog
        header="Postcodes"
        [(visible)]="postcodesDialogVisible"
        [responsive]="true"
        [modal]="true"
        [style]="{ width: '650px' }"
      >
        <div class="ui-grid-row ui-grid-responsive ui-fluid">
          <div class="map-container">
            <p-tabView #tabviewPostcodes>
              <p-tabPanel header="UK" #tabpanelPostcodesUK>
                <postcode-map-uk [datas]="ukcodes"></postcode-map-uk>
              </p-tabPanel>
              <p-tabPanel header="London">
                <postcode-map-london [datas]="londoncodes"></postcode-map-london>
              </p-tabPanel>
            </p-tabView>
          </div>
        </div>
        <div class="ui-grid-row">
          <div class="ui-g-12"></div>
        </div>
        <div class="ui-grid-row" style="float: right">
          <button
            type="button"
            class="green-btn"
            pButton
            icon="fa ui-icon-check"
            (click)="dlgSavePostcodes()"
            label="OK"
          ></button>
          <button
            type="button"
            pButton
            icon="fa ui-icon-close"
            label="Cancel"
            (click)="postcodesDialogVisible = false"
          ></button>
        </div>
      </p-dialog>
      <!-- loading template -->
      <ng-template #loading>Loading...</ng-template>
    </div>
  </div>
</div>
